<template>
  <span class="caption">
    <div class="font-weight-bold">
      {{ generateMessage('attachements.customerPlatform') }} :
    </div>
    <v-menu v-if="items.length" offset-y top :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <div v-on="on" class="mouse">
          <v-icon>{{ generateMessage('attachements.icon') }}</v-icon>
          {{
            generatePluralizedMessage(
              'attachements.documentsFound',
              items.length
            )
          }}
        </div>
      </template>
      <v-card>
        <v-list v-if="items.length">
          <v-list-item
            v-for="item in items"
            :key="item.uid"
            @click="download(item)"
          >
            <v-list-item-title v-if="downloading === item.id">
              <v-progress-circular
                indeterminate
                size="20"
                width="2"
                color="light-blue"
              ></v-progress-circular>
            </v-list-item-title>
            <v-list-item-title v-else>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <div v-else>
      {{
        isLoading
          ? generateMessage('attachements.loading')
          : generateMessage('attachements.noItems')
      }}
    </div>
  </span>
</template>

<script>
import { generateMessage, generatePluralizedMessage } from '@/utils/i18n';
import {
  getRequestDocuments,
  downloadRequestDocument,
} from '@/services/services/documentsService';

export default {
  name: 'attachementMenu',
  props: {
    requestId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      downloading: false,
      items: [],
    };
  },
  methods: {
    generateMessage,
    generatePluralizedMessage,
    getItems() {
      this.isLoading = true;
      getRequestDocuments(this.requestId)
        .then((documents) => {
          this.items = documents;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    download(item) {
      this.downloading = item.id;
      downloadRequestDocument(item.id)
        .then((file) => {
          const url = window.URL.createObjectURL(file);
          this.downloading = false;
          window.open(url);
        })
        .catch(() => {
          this.downloading = false;
        });
    },
  },
  watch: {
    requestId() {
      this.getItems();
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style scoped>
.mouse {
  cursor: pointer;
}
</style>
